import { render, staticRenderFns } from "./shell-icon.vue?vue&type=template&id=e6053466&scoped=true&"
import script from "./shell-icon.vue?vue&type=script&lang=ts&"
export * from "./shell-icon.vue?vue&type=script&lang=ts&"
import style0 from "./shell-icon.vue?vue&type=style&index=0&id=e6053466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6053466",
  null
  
)

export default component.exports